import { render, staticRenderFns } from "./ascertain-order.vue?vue&type=template&id=ba8886e8&scoped=true"
import script from "./ascertain-order.vue?vue&type=script&lang=js"
export * from "./ascertain-order.vue?vue&type=script&lang=js"
import style0 from "./ascertain-order.vue?vue&type=style&index=0&id=ba8886e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8886e8",
  null
  
)

export default component.exports